module.exports = __webpack_public_path__ + "img/user-alt-solid.c40fe570.svg";